import React, { useEffect } from 'react';
import WestIcon from '@mui/icons-material/West';
import { Box, useMediaQuery } from '@mui/material';
import TypographyComponent from 'components/Typography/Typography';
import { IntlShape } from 'react-intl';
import * as Styled from './EmptyResult.styles';
import { definedTranslation } from '../../i18n';

const EmptyResult: React.FC<{ intl: IntlShape }> = ({ intl }) => {
  const isMobile = useMediaQuery('(max-width: 1024px)');

  useEffect(() => {
    // Push event to dataLayer for tracking when there are no search results
    dataLayer.push({
      event: 'mb_site_error',
      error_type: 'search_zero_results',
      error_message: 'zero search results',
      error_interaction: 'zero results search',
      error_page: window.location.href || '',
    });
  }, []);

  const labels = {
    title: intl?.formatMessage(definedTranslation.noResults.title),
    subtitle: intl?.formatMessage(definedTranslation.noResults.subtitle),
  };

  function onClickBack() {
    window.location.href = '/search';
  }
  return (
    <Styled.Wrapper data-cnstrc-search data-cnstrc-zero-result>
      {isMobile ? (
        <Styled.BackWrapper onClick={onClickBack}>
          <WestIcon />
        </Styled.BackWrapper>
      ) : null}
      <Box
        display="flex"
        flexDirection="column"
        maxWidth={800}
        justifyContent="center"
        alignItems="center"
        gap="12px"
      >
        <TypographyComponent
          fontFamily="Graphik"
          fontSize={isMobile ? 36 : 80}
          fontWeight={600}
          variant={isMobile ? 'h3' : 'huge'}
          textAlign="center"
          mb="30px"
          maxWidth={isMobile ? '310px' : '680px'}
        >
          {labels.title}
        </TypographyComponent>
      </Box>
      <Box
        flexDirection="row"
        justifyContent="center"
        maxWidth={isMobile ? '343px' : 'unset'}
      >
        <TypographyComponent
          fontFamily="Graphik"
          fontSize={isMobile ? 16 : 24}
          fontWeight={400}
          variant="body"
          align="center"
          maxWidth={isMobile ? '310px' : 'unset'}
        >
          {labels.subtitle}
        </TypographyComponent>
      </Box>
    </Styled.Wrapper>
  );
};

export default EmptyResult;
